import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulateRelativeToRootFieldConfig,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  genericDataFetchFieldParseIntoSettingsFormModel,
  genericDataFetchFieldUpdateFromSettingsFormModel,
  getGenericDataFetchFieldSettingsConfig,
} from '../generic-datafetch-field-type.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomGenericDataFetchFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      url: '',
      useBaseUrl: true,
      endpointCode: '',
      useMultiplePayloadKeys: false,
      payloadKey: '',
      payloadKeyMappings: [],
      genericInputLength: 0,
      triggerType: 'INPUT_LENGTH',
      debounceTime: 500,
      defaultValue: null,
    };
    this.settingsFormlyForm = [
      ...getGenericDataFetchFieldSettingsConfig(this.formBuilderService),
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      {
        key: 'defaultValue',
        type: 'input',
        props: {
          label: 'Default value',
          placeholder: 'Enter default value',
        },
        validation: {
          messages: {
            maxLength: 'Default value is longer than Input Length value',
          },
        },
        expressions: {
          'props.maxLength': field => {
            return (
              field.parent?.model?.genericDataFetchFieldContentConfig
                ?.genericInputLength ?? null
            );
          },
        },
      },
      getPopulateRelativeToRootFieldConfig(),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, []),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return genericDataFetchFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return genericDataFetchFieldUpdateFromSettingsFormModel(this.field, model);
  }
}
